import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import AuthWrapper from "../wrappers/AuthWrapper";
import CustomTextField from "../components/fields/CustomTextField";
import validateEmail from "../utils/validateEmail";
import validateAgainPassword from "../utils/validateAgainPassword";
import validatePasswordPolicy from "../utils/validatePasswordPolicy";
import { signUp } from "../actions";
import CheckboxGroup from "../components/fields/CheckboxGroup";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: 350
  },
  button: {
    width: 300,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10
  },
  alreadySignIn: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto"
  }
});

const required_fields = [
  { name: "username", label: "username" },
  { name: "password", label: "password" },
  { name: "passwordAgain", label: "password" },
  { name: "email", label: "email" }
];

class SignUp extends Component {
 
    _handleSubmit = values => {
    this.props.signUp(values, this.props.history);
  };

  componentWillMount() {
    if (localStorage.getItem("sessionKey")) {
      this.props.history.push("/dashboard");
    }
  }

  render() {
    const { classes, sign } = this.props;

    const roleOptions = [
        { label: 'Admin', value: 1 },
        { label: 'User', value: 2 }
    ];

    return (
      <AuthWrapper>
        <Paper>
          <form
            className={classes.container}
            onSubmit={this.props.handleSubmit(this._handleSubmit)}
          >
            <Field
              fullWidth={true}
              name="username"
              type="text"
              id="username"
              label="Username"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="password"
              type="password"
              id="password"
              label="Password"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="passwordAgain"
              type="password"
              id="passwordAgain"
              label="Password Again"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="email"
              type="text"
              id="email"
              label="Email"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="fax"
              type="text"
              id="fax"
              label="Fax"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="companyName"
              type="text"
              id="companyName"
              label="Company Name"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="registrationNumber"
              type="text"
              id="registrationNumber"
              label="Registration Number"
              component={CustomTextField}
            />
            <Field
              fullWidth={true}
              name="contact"
              type="text"
              id="contact"
              label="Contact"
              component={CustomTextField}
            />
            <div>
                <label style={{ marginLeft: '25px', fontWeight: 'bold' }}>User Role</label>
                <CheckboxGroup name="roleList" options={roleOptions} />
            </div>
            {sign.error ? (
              <Typography component="p">{sign.error}</Typography>
            ) : null}
            <Button
              className={classes.button}
              type="submit"
              variant="contained"
              color="primary"
            >
              Sign Up
            </Button>
            <Typography className={classes.alreadySignIn} component="p">
              Already have an account? <Link to="/">Sign in here</Link>
            </Typography>
          </form>
        </Paper>
      </AuthWrapper>
    );
  }
}

function validate(values) {
  const errors = {};

  if (!validateEmail(values["email"])) {
    errors["email"] = "This email in invalid";
    }

    if (!validatePasswordPolicy(values["password"])) {
        errors["password"] = "This password is invalid (At least 1 uppercase, 1 lowercase, 1 digit, 6 - 20 characters)";
    }

    if (!validateAgainPassword(values["password"], values["passwordAgain"])) {
        errors["passwordAgain"] = "This confirmation password invalid";
    }

  required_fields.forEach(({ name, label }) => {
    if (!values[name]) {
      errors[name] = `You must provide ${label}`;
    }
  });

  return errors;
}

let SignUpWithStyles = withStyles(styles)(SignUp);

SignUpWithStyles = reduxForm({
  validate,
  form: "signUpForm"
})(SignUpWithStyles);

function mapStateToProps({ sign }) {
  return {
    sign
  };
}

export default connect(
  mapStateToProps,
  { signUp }
)(SignUpWithStyles);



// WEBPACK FOOTER //
// ./src/components/SignUp.js